const AJOUT_SPONSORING_DCF = {
  title: 'Ajouter un produit sponsoring / événementiel',
  brief: 'Mon brief',
  panier: 'Panier',
  table: {
    code: 'Code sponsoring / événementiel',
    libelle: 'Libellé',
    societe: 'Société',
    dateDebut: 'Date de début',
    dateFin: 'Date de fin',
    typeProduit: 'Type de produit',
  },
  briefContent: {
    libelle: 'Libellé',
    societe: 'Société',
    code: 'Code',
  },
};

export default AJOUT_SPONSORING_DCF;
